export const msalConfig = {
  auth: {
    clientId: "310cc207-20ab-4e16-968b-b1e1dd7907cf",
    authority: "https://login.microsoftonline.com/33c9e029-bb7d-480a-b948-d7af10152f1e",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "Sites.ReadWrite.All",
  ],
};

export const SHAREPOINT_SITE = "https://leerowsro.sharepoint.com/sites/LRPlanning";
